import { render } from "./PatientsWidget.vue?vue&type=template&id=03663492&scoped=true"
import script from "./PatientsWidget.vue?vue&type=script&lang=js"
export * from "./PatientsWidget.vue?vue&type=script&lang=js"

import "./PatientsWidget.vue?vue&type=style&index=0&id=03663492&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03663492"]])

export default __exports__